import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Col, Table } from 'reactstrap';
import { useEffect, useState } from 'react';
import { PickupStatsCategories, formatdecider, pickupIsInCategory } from '../../../../helpers';
import { IAdHocRoundBoxScoreDto } from '../../../../WorldDoomLeague';

interface AdHocMatchOverallPickupsTableProps {
    activeCategory: PickupStatsCategories;
    finalBoxScore: IAdHocRoundBoxScoreDto;
};

const AdHocMatchOverallPickupsTable = (props: AdHocMatchOverallPickupsTableProps) => {
    const [redPlayers, setRedPlayers] = useState<number[]>([]);
    const [bluePlayers, setBluePlayers] = useState<number[]>([]);
    const [greenPlayers, setGreenPlayers] = useState<number[]>([]);
    const [nonePlayers, setNonePlayers] = useState<number[]>([]);

    const [redPickups, setRedPickups] = useState<string[]>([]);
    const [bluePickups, setBluePickups] = useState<string[]>([]);
    const [greenPickups, setGreenPickups] = useState<string[]>([]);
    const [nonePickups, setNonePickups] = useState<string[]>([]);

    const getRedTeamPlayers = (boxscore: IAdHocRoundBoxScoreDto) => {
        var redPlayers = [] as number[];
        boxscore.redTeamPlayerRoundBoxScore.map((s, idx) => {
            redPlayers.push(s.playerId);
        });

        return redPlayers;
    };

    const getBlueTeamPlayers = (boxscore: IAdHocRoundBoxScoreDto) => {
        var bluePlayers = [] as number[];
        boxscore.blueTeamPlayerRoundBoxScore.map((s, idx) => {
            bluePlayers.push(s.playerId);
        });

        return bluePlayers;
    };

    const getGreenTeamPlayers = (boxscore: IAdHocRoundBoxScoreDto) => {
        var greenPlayers = [] as number[];
        boxscore.greenTeamPlayerRoundBoxScore.map((s, idx) => {
            greenPlayers.push(s.playerId);
        });

        return greenPlayers;
    };

    const getNoneTeamPlayers = (boxscore: IAdHocRoundBoxScoreDto) => {
        var nonePlayers = [] as number[];
        boxscore.nonTeamPlayerRoundBoxScore.map((s, idx) => {
            nonePlayers.push(s.playerId);
        });

        return nonePlayers;
    };

    const getRedTeamPickups = (boxscore: IAdHocRoundBoxScoreDto, category: PickupStatsCategories): string[] => {
        var pickupTypes: string[] = [];
        boxscore.redTeamPlayerRoundBoxScore.map((m, idx) => {
            m.pickupStats.map((s, _idx) => {
                if (pickupIsInCategory(category, s.pickupType) && pickupTypes.every(e => e !== s.pickupType)) {
                    pickupTypes = [...pickupTypes, s.pickupType]
                }
            })
        });

        return pickupTypes;
    }

    const getBlueTeamPickups = (boxscore: IAdHocRoundBoxScoreDto, category: PickupStatsCategories): string[] => {
        var pickupTypes: string[] = [];
        boxscore.blueTeamPlayerRoundBoxScore.map((m, idx) => {
            m.pickupStats.map((s, _idx) => {
                if (pickupIsInCategory(category, s.pickupType) && pickupTypes.every(e => e !== s.pickupType)) {
                    pickupTypes = [...pickupTypes, s.pickupType]
                }
            })
        });

        return pickupTypes;
    }

    const getGreenTeamPickups = (boxscore: IAdHocRoundBoxScoreDto, category: PickupStatsCategories): string[] => {
        var pickupTypes: string[] = [];
        boxscore.greenTeamPlayerRoundBoxScore.map((m, idx) => {
            m.pickupStats.map((s, _idx) => {
                if (pickupIsInCategory(category, s.pickupType) && pickupTypes.every(e => e !== s.pickupType)) {
                    pickupTypes = [...pickupTypes, s.pickupType]
                }
            })
        });

        return pickupTypes;
    }

    const getNoneTeamPickups = (boxscore: IAdHocRoundBoxScoreDto, category: PickupStatsCategories): string[] => {
        var pickupTypes: string[] = [];
        boxscore.nonTeamPlayerRoundBoxScore.map((m, idx) => {
            m.pickupStats.map((s, _idx) => {
                if (pickupIsInCategory(category, s.pickupType) && pickupTypes.every(e => e !== s.pickupType)) {
                    pickupTypes = [...pickupTypes, s.pickupType]
                }
            })
        });

        return pickupTypes;
    }

    const createRedPlayerTableRow = () => {
        var redRows = [];
        var redRow = [];
        redPlayers.map((s, idx) => {
            redRow.push(<th scope="row">{props.finalBoxScore.redTeamPlayerRoundBoxScore.find(f => f.playerId === s).playerName}</th>);

            redPickups.map((t, _idx) => {
                const player = props.finalBoxScore.redTeamPlayerRoundBoxScore.find(f => f.playerId === s);
                const amount = player.pickupStats.find(f => f.pickupType === t)?.pickupAmount ?? 0;
                redRow.push(<td>{amount > 0 ? amount : '-'}</td>);
            })

            redRows.push(<tr className='bg-danger'>{redRow}</tr>);
            redRow = [];
        });


        return (redRows);
    };

    const createBluePlayerTableRow = () => {
        var blueRows = [];
        var blueRow = [];
        bluePlayers.map((s, idx) => {
            blueRow.push(<th scope="row">{props.finalBoxScore.blueTeamPlayerRoundBoxScore.find(f => f.playerId === s).playerName}</th>);

            bluePickups.map((t, _idx) => {
                const player = props.finalBoxScore.blueTeamPlayerRoundBoxScore.find(f => f.playerId === s);
                const amount = player.pickupStats.find(f => f.pickupType === t)?.pickupAmount ?? 0;
                blueRow.push(<td>{amount > 0 ? amount : '-'}</td>);
            })

            blueRows.push(<tr className='bg-primary'>{blueRow}</tr>);
            blueRow = [];
        });

        return (blueRows);
    };

    const createGreenPlayerTableRow = () => {
        var greenRows = [];
        var greenRow = [];
        greenPlayers.map((s, idx) => {
            greenRow.push(<th scope="row">{props.finalBoxScore.greenTeamPlayerRoundBoxScore.find(f => f.playerId === s).playerName}</th>);

            greenPickups.map((t, _idx) => {
                const player = props.finalBoxScore.greenTeamPlayerRoundBoxScore.find(f => f.playerId === s);
                const amount = player.pickupStats.find(f => f.pickupType === t)?.pickupAmount ?? 0;
                greenRow.push(<td>{amount > 0 ? amount : '-'}</td>);
            })

            greenRows.push(<tr className='bg-success'>{greenRow}</tr>);
            greenRow = [];
        });

        return (greenRows);
    };

    const createNonePlayerTableRow = () => {
        var noneRows = [];
        var noneRow = [];
        nonePlayers.map((s, idx) => {
            noneRow.push(<th scope="row">{props.finalBoxScore.nonTeamPlayerRoundBoxScore.find(f => f.playerId === s).playerName}</th>);

            nonePickups.map((t, _idx) => {
                const player = props.finalBoxScore.nonTeamPlayerRoundBoxScore.find(f => f.playerId === s);
                const amount = player.pickupStats.find(f => f.pickupType === t)?.pickupAmount ?? 0;
                noneRow.push(<td>{amount > 0 ? amount : '-'}</td>);
            })

            noneRows.push(<tr className='bg-secondary'>{noneRow}</tr>);
            noneRow = [];
        });

        return (noneRows);
    };

    useEffect(() => {
        setRedPlayers(getRedTeamPlayers(props.finalBoxScore));
        setBluePlayers(getBlueTeamPlayers(props.finalBoxScore));
        setGreenPlayers(getGreenTeamPlayers(props.finalBoxScore));
        setNonePlayers(getNoneTeamPlayers(props.finalBoxScore));

        setRedPickups(getRedTeamPickups(props.finalBoxScore, props.activeCategory));
        setBluePickups(getBlueTeamPickups(props.finalBoxScore, props.activeCategory));
        setGreenPickups(getGreenTeamPickups(props.finalBoxScore, props.activeCategory));
        setNonePickups(getNoneTeamPickups(props.finalBoxScore, props.activeCategory));
    }, [props.activeCategory]);

    return (
        <React.Fragment>
            {bluePlayers.length > 0 && (
                <Row>
                    <Col>
                        <Table responsive size="sm">
                            <thead>
                                <tr>
                                    <th> </th>
                                    {bluePickups.map((s, idx) => (
                                        <th>{s}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {createBluePlayerTableRow()}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}

            {redPlayers.length > 0 && (
                <Row>
                    <Col>
                        <Table responsive size="sm">
                            <thead>
                                <tr>
                                    <th> </th>
                                    {redPickups.map((s, idx) => (
                                        <th>{s}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {createRedPlayerTableRow()}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}

            {greenPlayers.length > 0 && (
                <Row>
                    <Col>
                        <Table responsive size="sm">
                            <thead>
                                <tr>
                                    <th> </th>
                                    {greenPickups.map((s, idx) => (
                                        <th>{s}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {createGreenPlayerTableRow()}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}

            {nonePlayers.length > 0 && (
                <Row>
                    <Col>
                        <Table responsive size="sm">
                            <thead>
                                <tr>
                                    <th> </th>
                                    {nonePickups.map((s, idx) => (
                                        <th>{s}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {createNonePlayerTableRow()}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
};

export default AdHocMatchOverallPickupsTable;